import { useRouter } from '@tanstack/react-router';
import { XCircle } from 'lucide-react';

import { Button } from '@/shared/ui/button';
import { PageContainer } from '@/shared/ui/page-container';

const pageBackgroundClass = 'min-h-screen bg-slate-50 text-slate-700';

export const PaymentCancelPage = () => {
  const router = useRouter();

  const handleRetry = () => {
    router.navigate({
      to: '/payment/select-course',
      search: {
        status: undefined,
        session_id: undefined,
      },
    });
  };

  return (
    <main className={pageBackgroundClass}>
      <PageContainer maxWidth="mobile">
        <div className="flex py-12">
          <section className="w-full rounded-2xl border border-slate-200 bg-white px-10 py-12 text-center shadow-sm">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-red-200 bg-red-50 text-red-500 shadow-sm">
            <XCircle className="h-8 w-8" />
          </div>

          <h1 className="mt-8 text-2xl font-semibold text-slate-900 sm:text-3xl">
            Payment cancelled
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-500 sm:text-base">
            Your payment was cancelled before completion. You can return
            to the course selection page to retry or choose another
            package.
          </p>

          <Button
            onClick={handleRetry}
            variant="default"
            size="lg"
            className="mt-10 inline-flex min-w-48 items-center justify-center"
          >
            Choose a package
          </Button>
        </section>
        </div>
      </PageContainer>
    </main>
  );
};
